<template>
  <list-view-filter-base
    :filter-element="filterElement"
    :key="filterElement.id"
  ></list-view-filter-base>
</template>

<script lang="ts">
  import Vue from "vue";
  import filterElementBaseMixin from "../../../common/mixins/listViews/filterElementBaseMixin";

  export default Vue.extend({
    mixins: [
      filterElementBaseMixin,
    ],
  });
</script>